import { LOCALE_ID, Inject, Injectable } from '@angular/core';
import { CalendarEventTitleFormatter, CalendarEvent } from 'angular-calendar';
import { DatePipe } from '@angular/common';
import { CalendarEventActionsComponent } from 'angular-calendar/modules/common/calendar-event-actions.component';

@Injectable()
export class CustomEventTitleFormatter extends CalendarEventTitleFormatter {
    constructor(@Inject(LOCALE_ID) private locale: string) {
        super();
    }

    // you can override any of the methods defined in the parent class
    isSameDay(d1, d2) {
        return (
            d1.getFullYear() === d2.getFullYear() &&
            d1.getMonth() === d2.getMonth() &&
            d1.getDate() === d2.getDate()
        );
    }

    month(event: CalendarEvent): string {
        console.log(this.locale);
        this.locale = 'en-US';
        let formate;
        if (!this.isSameDay(event.start, event.end)) {
            formate = 'dd MMM, HH:mm';
        } else {
            formate = 'HH:mm';
        }

        return `${new DatePipe(this.locale).transform(
            event.start,
            formate,
            this.locale
        )} - ${new DatePipe(this.locale).transform(
            event.end,
            formate,
            this.locale
        )} ${event.title}`;
    }

    // week(event: CalendarEvent): string {

    //   return event.title;
    //   this.locale = 'en-US';
    //   let formate;
    //   if (!this.isSameDay(event.start, event.end)) {
    //     formate = 'dd MMM, HH:mm';
    //   } else {
    //     formate = 'HH:mm';
    //   }

    //   return `${new DatePipe(this.locale).transform(
    //     event.start,
    //     formate,
    //     this.locale
    //   )} - ${new DatePipe(this.locale).transform(
    //     event.end,
    //     formate,
    //     this.locale
    //   )} ${event.title}`;
    // }

    day(event: CalendarEvent): string {
        return `<b>${new DatePipe(this.locale).transform(
            event.start,
            'h:m a',
            this.locale
        )}</b> ${event.title}`;
    }
}
